// extracted by mini-css-extract-plugin
export default {"shareFooterUrl":"FooterUrl_shareFooterUrl__YU6t+","info":"FooterUrl_info__7fzoR","url":"FooterUrl_url__lnei5","copyright":"FooterUrl_copyright__lROTd"};